import { NoiseFrequencyRating } from "../enums/noiseFrequencyRating.enum";
import { OelCorrectionMethod } from "../enums/oelCorrectionMethod.enum";
import { TWACorrectionMethod } from "../enums/TWACorrectionMethod.enum";
import { AdjustmentClassificationEnum } from "../enums/adjustmentClassification.enum";

export class AgentJurisdiction {
    id?: string;
    jurisdictionId: string;
    masterAgentId: string;
    al: number | null;
    oel: number | null;
    ceilingLimit: number | null;
    stel: number | null;
    exchangeRate: number | null;
    threshold: number | null;
    noiseFrequencyRating: NoiseFrequencyRating;
    noiseSpeed: number | null;
    masterAgentName: string;
    jurisdictionName: string;
    addedToMySite?: boolean;
    oelTypeId?: string;
    oelTypeName?:string;
    oelCorrectionMethod?: OelCorrectionMethod;
    twaCorrectionMethod?: TWACorrectionMethod;
    adjustmentClassification?: AdjustmentClassificationEnum | null;
    agentUnits?: number;
    analyticalMethodId?: string;
    effectiveStart?: string;
    effectiveEnd?: string;
    sourceRef?: string;
    oelValue?: string;
    statusLabel?: string;
    statusClass?: string;
    effectivePeriodDisplay?: string;
    isHistorical?: boolean;
}

export class AgentJurisdictionRecordHistory extends AgentJurisdiction {
    // DASH-2681: true only for the single live/open version; drives the Current/Historical flyout label.
    isCurrent?: boolean;
    dateUpdated?: string;
    updatedByUserId?: string;
    updatedByUserName?: string;
    createdByUserName?: string;
    isDeleted?: boolean;
    changedFields?: string;
    changedFieldsArray?: string[];
    changedFieldSet?: Set<string>;
    dateUpdatedDisplay?: string;
    effectiveStartDisplay?: string;
    effectiveEndDisplay?: string;
}

export class JurisdictionsOverviewData {
    jurisdictionsCount: number;
    jurisdictionsMissingAgentCount: number;
}

export class AgentsOverviewData {
    agentsCount: number;
    agentsMissingJurisdictionCount: number;
    airCount: number;
    noiseCount: number;
    wipeCount: number;
    biologicalCount: number;
    psychologicalCount: number;
    vibrationCount: number;
}

